//#region src/utils/i18n.ts
const getTargetBlankA11yHint = (i18n) => i18n.t({
	id: "0dkadJ",
	message: " (opens in new tab)"
});
//#endregion
export { getTargetBlankA11yHint };

//# sourceMappingURL=i18n.js.map